import Widget from './Widget.jsx';
import Utility from '../core/Utility.js';
import PresetStatus from './PresetStatus.js';
import Translate from '../core/Translate.js';
import PresetService from './PresetService.js';
import WidgetService from './WidgetService.js';

class Preset {
	constructor(meta, store, msgbus, isReadOnly = true, options = {},$q) {
		this.msgbus = msgbus;
		this.status = PresetStatus.Ready;
		this.store = store;
		this.guid = meta.guid;
		this.meta = meta.state;
		this.token;
		this.lastSet = [];
		this.$q = $q;
		this.tempWidget = null;
		//this.lastValType = [];
		console.warn(meta)


		// this.meta.widgets.push({
		// 	"data": {
		// 		"filters": [],
		// 		"source": { "guid": "2efa334f-6cdd-2662-8040-73a7db460437"},
		// 		"order": [
		// 		]
		// 	},
		// 	"name":"그리드","guid":"sample-widget","type":"grid"
		// })

/*
		this.meta = {
			"layout":[{"w":100,"rows":[{"h":100,"cols":[{"w":40,"guid":"sample-widget"},{"w":20,"guid":"sample-widget-2"},{"w":40,"guid":"sample-widget-3"}]}]}],
			"widgets":[{"data":{"filters":[],
				"source":{"guid":'sample-data-source'},
				"order":[
					{"type":"number","align":"right","key":"count","formatting":","},
					{"type":"datetime","key":"_time"},
					{"type":"string","key":"table"}
					]
				},
				"name":"그리드","guid":"sample-widget","type":"grid"},

				{"data":{
				"source":{"guid":'sample-data-source'},
				"criteria": "table"
				},
				"name":"필터","guid":"sample-widget-2","type":"filter"},

				{"data":{"filters":[],
				"source":{"guid":'instant-1', 'instant': true},
				"query": "logdb table | eval val=rand(100)",
				"order":[
					{"type":"number","align":"right","key":"val","formatting":","},
					{"type":"number","align":"right","key":"count","formatting":","},
					{"type":"datetime","key":"_time"},
					{"type":"string","key":"table"}
					]
				},
				"name":"그리드subcommand","guid":"sample-widget-3","type":"grid"},
			],"version":"2.0.1"
		}
*/

		// this.initInstantDataSource();

		this.widgets = [];
		this.isReadOnly = isReadOnly;
		this.options = options;
		this.parentGuid = meta.parent;
	}

	triggerDownload (imgURI, nameExtension) {
		var a = document.createElement('a');
		a.setAttribute('download', this.options.getCurrentTab().name + '_preset.'+nameExtension);
		a.setAttribute('href', imgURI);
		a.setAttribute('target', '_blank');
		a.click();
	}

	takeAllSnapShot(){
		var deferredQueue = [];
		this.widgets.forEach(w => {
			var defer = this.$q.defer();
			deferredQueue.push(defer.promise);
			w.takeSnapShot(true, defer);
		});
		this.$q.all(deferredQueue).then(()=>{
			var thisTab = this.options.el.find('.dockpanel[tab-id="' + this.guid + '"]');
			html2canvas(thisTab[0],{
				onrendered: (tabCanvas) => {
					var imgURI = tabCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
					this.triggerDownload(imgURI, 'png');
					this.widgets.forEach(w => {
						w.hideScreenShot(()=>{
							w._resume();
						});
					});
				}
			});
		})
	}


	initLayout() {
		var self = this;
		return LayoutEngine.createBox(this.meta.layout[0], false, {
			'onDrag': function(box, em, ed) {
			},
			'onDrop': function(box, event, targetDockId) {
			},
			'onAppend': function(box, event, targetDockId) {
				//이미 만들어져있는 위젯을 옮길때 불림. onAppend 다음에 onDelete가 불리므로 onDelete에서만 저장하면 된다.
				self.removeTempWidget();
			},
			'onModify': function(box) {
			},
			'onDelete':  Utility.debounce(function(box) {
				//위젯 삭제 혹은 위젯 옮길때 맨 마지막에 불림.
				// layout engine자체가 row에 있는것들을 지우고 다시 재정렬 하는 부분에서 onDelete가 한번에 많이 불리는 경향이 있어 debounce를 걸어놓음.
				self.resizeWidgets.call(self);
				self.savePreset();
			}, 200),
			'afterResize': function(row, box) {
				self.resizeWidgets.call(self);
				self.savePreset();
			}
		});
	}

	resetWidget(currentWidgets) {
		this.activeWidgets();
	}

	initWidget() {
		this.meta.widgets.forEach(ctx => {
			var w = new Widget(ctx, this.store, {
				'isReadOnly': this.isReadOnly,
				'elDock': this.options.el,
				'events': {
					'rendered': this.onWidgetRenderedEvent.bind(this),
					'infoClick': this.onWidgetInfoClick.bind(this),
					'closeClick': this.onWidgetCloseClick.bind(this),
					'failClick': this.onWidgetFailClick.bind(this),
					'titleChanged': this.onWidgetTitleChanged.bind(this),
					'setValue': this.onSetValue.bind(this),
					'filtered': this.onWidgetFiltered.bind(this),
					'filterReset': this.onWidgetFilterReset.bind(this),
					'contextChanged': this.onWidgetContextChanged.bind(this),
					'setParamsReset':this.onResetValue.bind(this)
				},
				'theme': this.options.theme
			},
			this.guid,
			this.$q);
			this.widgets.push(w);
			w.option = PresetService.getPresetInfo();
			w.resume();
		});
		this.status = PresetStatus.Active;
	}

	onWidgetInfoClick(w) {
		this.options.onInfoClick(w);
	}

	onWidgetRenderedEvent(service) {
		var e = new Event('themeChange');
		if(service instanceof DashboardWidget) {
			service.dispatchEvent(e);
		}
	}

	onWidgetCloseClick(w) {
		var sure = confirm(Translate.get("$S_msg_ConfirmDeleteWidget"));
		if(sure) {
			var idx = this.widgets.indexOf(w);
			this.widgets.splice(idx, 1);
		}
		return sure;
	}

	onWidgetFailClick(w) {
		this.options.onFailClick(w);
	}

	onWidgetTitleChanged(newval) {
		this.savePreset();
	}

	onWidgetContextChanged() {
		this.savePreset();
	}

	onWidgetFiltered(widget, datasource, filterString) {
		if(!!datasource) {
			datasource.clearAndAddFilter(filterString);
/*
			this.widgets.forEach(w => {
				if (!!w.model && !!w.model.datasource && datasource.guid === w.model.datasource.guid && !!w.rendered ) {
					var e = new Event('widgetFiltered');
					e.detail = filterString;
					w.rendered.dispatchEvent(e);
				}
			});*/	
		}
	}

	onWidgetFilterReset(widget, datasource) {
//		console.log('onWidgetFilterReset', datasource);
		if(!!datasource) {
			datasource.clearFilter();
		}
	}

	/*
	아래 함수들은 볼드모트디자인 때문에 필요했던 함수들로, 불필요하게 상위 까지 call을 타는 경향이 있어 삭제함.
	// onSetParameterReset(fn) {
	// 	this._onSetReset = fn;
	// 	return this;
	// }

	// onSetParameterChanged(fn) {
	// 	this._onSetChanged = fn;
	// 	return this;
	// }
	*/

	applyCustomQuery(){
		console.log("applyCustomQuery" , this.lastSet);
		this.widgets.forEach(widget => {
			if(!widget.isCustomQueryWidget){ // custom widget은 쿼리를 하지 않아야 하므로 prepend 할 필요가 없음.
				widget.model.setPrependParams(this.lastSet);
				widget._restart(); //#2700, restart로 바꿈. model 안에서 restart 하면 widget의 state 관리가 안됨, _resume을 하면 멈춰있던 위젯들도 다시 살아남...
			}
		})
	}

	onResetValue(customWidgetGuid){
		this.removeOldSetValue(customWidgetGuid);
		this.applyCustomQuery();
	}

	removeOldSetValue(guid){
		var idx = undefined;
		this.lastSet.forEach( (set, i) => {
			if(set.customWidgetGuid === guid){
				idx = i;
			}
		})
		if(!!idx || idx == 0){
			this.lastSet.splice(idx, 1);
		}
	}

	//set 기능 추가때문에 수정.
	onSetValue(e, map) {
	//	console.log("onSetValue map = ", map);
		if(map.valType === undefined){
			map['valType'] = 'string';
		}
		this.removeOldSetValue(map.customWidgetGuid);
		this.lastSet.push(map);
		this.applyCustomQuery();
	}

	activeWidgets() {
		this.widgets.forEach(w => {
			w.option = PresetService.getPresetInfo();
			w.resume();
		});
	}

	resume() {
		// if(this.status == PresetStatus.Ready) {
			this.initWidget();
		// }
		// else {
		// this.activeWidgets();
		// }
	}

	suspend() {
		this.removeTempWidget();
		this.widgets.forEach(w => {
			w.destroy();
		})
		this.widgets = [];
	}

	stopTimer() {
		// var keys = Object.keys(this.store.sources);
		// keys.forEach(key => {
		// 	var model = this.store.sources[key];
		// 	model.stopRequest();
		// });
	}

	startTimer() {
		// var keys = Object.keys(this.store.sources);
		// keys.forEach(key => {
		// 	var model = this.store.sources[key];
		// 	model.request();
		// });
	}

	render(el) {
		this.rootbox = this.initLayout();
		this.rootbox.appendTo(el);
	}

	resizeWidgets() {
		this.widgets.forEach(widget => {
			if(!!widget.rendered && typeof widget.rendered.dispatchEvent === 'function') {
				var e = new Event('resize');
				widget.rendered.dispatchEvent(e);
			}
		});
	}

	setTheme(param) {
		this.widgets.forEach(w => {
			w.setTheme(param);
			if(!!w.rendered && typeof w.rendered.dispatchEvent === 'function') {
				var e = new Event('themeChange');
				e.detail = param;
				w.rendered.dispatchEvent(e);
			}

			// legacy
			if(!!w.rendered && typeof w.rendered.setStyle === 'function') {
				w.rendered.setStyle(param);
			}
		});
	}

	removeTempWidget(){
		if(!!this.tempWidget){
			var elBox = this.options.el.find('.newbie');
			if(!!elBox){
				elBox.remove();
			}
			this.tempWidget.destroy();
			this.tempWidget = null;
		}
	}

	addComplete(){
		if(!!this.tempWidget){
			this.widgets.push(this.tempWidget);
			this.tempWidget = null;
		}
	}

	addWidget(ctx) {
		console.log("preset widget ctx = ", ctx);
		var w = new Widget(ctx, this.store, {
			'isReadOnly': this.isReadOnly,
			'elDock': this.options.el,
			'events': {
				'rendered': this.onWidgetRenderedEvent.bind(this),
				'infoClick': this.onWidgetInfoClick.bind(this),
				'closeClick': this.onWidgetCloseClick.bind(this),
				'failClick': this.onWidgetFailClick.bind(this),
				'titleChanged': this.onWidgetTitleChanged.bind(this),
				'setValue': this.onSetValue.bind(this),
				'filtered': this.onWidgetFiltered.bind(this),
				'filterReset': this.onWidgetFilterReset.bind(this),
				'contextChanged': this.onWidgetContextChanged.bind(this),
				'setParamsReset':this.onResetValue.bind(this)
			}
		},this.guid,
		this.$q);
		w.option = PresetService.getPresetInfo();

		this.tempWidget = w;
		// set function관련하여 나중에 추가되는 widget에도 그전에 set한 값으로 초기화 해주기 위하여 해당 코드 추가.
		if(this.lastSet.length > 0){
			this.applyCustomQuery();
			//w.model.setPrependParams(this.lastSet, this.lastValType);
		}
		this.tempWidget.resume();
	}

	updateWidget(ctx) {
		var w = this.widgets.find(w => {
			return w.guid == ctx.guid;
		});
		w.updateContext(ctx);
	}

	savePreset() {
		return new Promise((resolve, reject) => {
			var obj ={};
			var tab;
			if(this.status == PresetStatus.Active) {
				tab = this.options.el.find('.dockpanel[tab-id="' + this.guid + '"] > .k-d-col');

				var stateObject = {};
				obj.guid = this.guid;
				obj.name = this.guid;
				stateObject.version = '2.0.1',
				stateObject.widgets = this.widgets.map(w => {
					var ctx = Object.assign({}, w.ctx);
					var data = Object.assign({}, w.ctx.data);
					delete data['$$interval'];

					ctx.data = data;
					ctx.columns = w.columns.map(c => {
						return {
							'type': c.type,
							'key': c.key
						};
					});
					return ctx;
				});
				stateObject.layout = [
					tab[0].obj.getObject()
				]

				obj.state = Object.assign({}, this.meta, stateObject);
				obj.parent = this.parentGuid;

				if(!Array.isArray(obj.state.layout[0].rows)) {
					obj.state.layout[0].blank = true;
				}
				this.meta = obj.state;
			}
			else {
				obj = {
					guid: this.guid,
					name: this.guid,
					state: this.meta,
					parent: this.parentGuid
				};
			}

			//console.log(JSON.stringify(obj.state));

			if(!this.isReadOnly) {
				console.log("save object = ", obj);
				// console.log('----try to save -----');
				// return;
				//console.warn('------- saved!! -------');
				PresetService.setPreset(this.msgbus, obj).onSuccess(resolve);
			}
		});
	}
}

export default Preset;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/Preset.js